/* eslint-ignore */
// @ts-nocheck
import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const Container = styled(Modal.Body)`
  background-color: #ffffff;
  border-radius: 20px;
  width: 100%;
  height: auto;
  padding: 30px;
  overflow-x: hidden;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Left = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
`;

export const Title = styled.span`
  font-weight: bold;
  font-size: 26px;
  color: #0018FF;
  @media (max-width: 375px) {
    font-size: 23px;
  }
`;

export const CloseIcon = styled.span`
  font-size: 20px;
  margin-top: -50px;
  margin-right: -11px;
  color: #0011FF  ;
  cursor: pointer;
  @media (max-width: 370px) {
    font-size: 18px;
  }
`;

export const Content = styled.div`
  width: 100%;
  height: auto;
`;

export const InfoContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  color: #0011FF;
`;

export const InfoTitle = styled.span`
  font-size: 1rem;  
  font-weight: 700;
`;

export const InfoText = styled.span`
  color: #808495;
  font-size: 1rem;
`;

export const Hr = styled.hr``;

export const StatusIcon = styled.div`
  background-color: ${(props) => props.color};
  width: 10px;
  height: 10px;
  border-radius: 5px;
  margin-right: 5px;
`;

export const DetailsContainer = styled.div`
  width: 100%;
  height: auto;
  padding-top: 10px;
  padding-bottom: 10px;

  background: #f1f3f4;
  padding: 16px;
  border-radius: 8px;

  ${InfoTitle} {
    color: #0011FF;
    font-size: 1rem;
  }
`;

export const SectionTitle = styled.span`
  color: #0018FF;
  font-size: 1.1rem;
  font-weight: 600;
`;

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 28px;
`;
